import { App, Server, CVSSv2, CVSSv3 } from './cve-interfaces'

export type FindCvssReturnType =
  | {
      cvssv2: CVSSv2
      cvssv3: undefined
    }
  | { cvssv3: CVSSv3; cvssv2: undefined }

export const findCvssVersion = (
  cvssv2: CVSSv2,
  cvssv3: CVSSv3 | null | undefined
): FindCvssReturnType => {
  return cvssv3 === null || cvssv3 === undefined
    ? { cvssv2, cvssv3: undefined }
    : { cvssv2: undefined, cvssv3 }
}

export const getApps = (appsArray: App[] | Server[]) =>
  appsArray.map((app: { name: string }) => app.name)

export const getColorBySeverity = (sev: string) => {
  switch (sev) {
    case 'CRITICAL':
      return 'red50'
    case 'HIGH':
      return 'orange50'
    case 'MEDIUM':
      return 'yellow50'
    case 'LOW':
      return 'neutral40'
    default:
      return 'neutral40'
  }
}

export const formatEpochToDate = (epoch) => {
  const date = new Date(epoch)
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  const year = date.getFullYear()

  return `${month}/${day}/${year}`
}
